import styles from "./addtaskform.module.css";
import { Box, Button, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Plus } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../components/AddLogs";
import { toast } from 'react-smart-toaster';
import TaskListCard from "./TaskListCard";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const schema = yup.object().shape({
    title: yup.string().required("This field is Required"),
    description: yup.string(),
    property_id: yup.string(),
    technicians: yup.string(),
    days: yup.array(),
});

const daysList = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];

const AddTaskForm = ({ setAddTaskModalOpen, setLoading, setSnackbarOpen, setSnackbarMsg, addTaskLocal }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [addTaskOpen, setAddTaskOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);
    const [allTechnicianList, setAllTechnicianList] = useState([]);
    const [technicianList, setTechnicianList] = useState([]);
    const [selectDays, setSelectDays] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [taskVal, setTaskVal] = useState('');
    const [taskError, setTaskError] = useState(false);
    const [charsLeft, setCharsLeft] = useState({ description: 200 });
    const [activeTaskId, setActiveTaskId] = useState(null);

    const { handleSubmit, control, errors, setValue } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            days: [],
            technicians: ''
        }
    });

    useEffect(() => {
        async function fetchPropertyList() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_CASE_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch(() => { });
        }
        fetchPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function fetchPropertyList() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_CASE_API_URL + "v1/technician-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setAllTechnicianList(response.data.data);
            }).catch(() => { });
        }
        fetchPropertyList();
    }, [getAccessTokenSilently]);

    const onSubmit = async (data) => {
        setLoading(true);
        setAddTaskModalOpen(false);

        data = { ...data, taskList: taskList };

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.post(process.env.REACT_APP_CASE_API_URL + "v1/tasks", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            addTaskLocal(response.data.data);

            let logData = {
                'title': 'A new task list has been added',
                'description': [
                    'Name: ' + response?.data?.data?.title,
                    'Property: ' + response?.data?.data?.property_name,
                    'Technician: ' + response?.data?.data?.technician_name
                ]
            }
            AddLogCallAPI(logData, token);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const addTask = () => {
        if (taskVal !== '') {
            setAddTaskOpen(false);
            setTaskList(prev => {
                return prev.concat(taskVal);
            })
        } else {
            setTaskError(true);
        }
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.AddprospectFirstStepForm}`}>
            <div className={`${styles.FormArea}`}>
                <div className={`${styles.AddPropertyHalfSecRow}`}>
                    <div className={`${styles.HalfSecFull} FormGroup`}>
                        <Controller
                            name={`title`}
                            control={control}
                            render={(field) => (<TextField
                                {...field}
                                id="outlined-basic"
                                label="Task name*"
                            />)}
                        />
                        {errors.title && (<p className={`${styles.ErrorM}`}>{errors?.title?.message}</p>)}
                    </div>
                    <div className={`${styles.HalfSecFull} FormGroup`}>
                        <Controller
                            name={`description`}
                            control={control}
                            render={(field) => (<TextField
                                {...field}
                                id="outlined-basic"
                                label="Description"
                                multiline
                                rows={4}
                                onChange={(e) => {
                                    field.onChange(e);

                                    setCharsLeft((prev) => {
                                        return { ...prev, description: 200 - e.target.value.length };
                                    });
                                }}
                                inputProps={{ maxLength: 200 }}
                            />)}
                        />
                        <p className={`${styles.Example}`}>{charsLeft?.description > 1 ? charsLeft?.description + " characters remaining" : charsLeft?.description + " character remaining"}</p>
                        {errors.description && (<p className={`${styles.ErrorM}`}>{errors?.description?.message}</p>)}
                    </div>
                </div>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Controller
                            name="property_id"
                            control={control}
                            render={(field) => (
                                <Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Property"
                                    onChange={(e) => {
                                        field.onChange(e);

                                        let technicianListTemp = allTechnicianList?.filter(i => i?.properties?.indexOf(e?.target?.value) > -1);

                                        setTechnicianList(technicianListTemp);
                                        setValue('technicians', '');
                                    }}
                                >
                                    {propertyList?.map((item) => {
                                        return (<MenuItem value={item.value}>{item.label}</MenuItem>);
                                    })}
                                </Select>
                            )}
                        />
                    </FormControl>
                    {errors.property_id && (<p className={`${styles.ErrorM}`}>{errors?.property_id?.message}</p>)}
                </div>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Technicians</InputLabel>
                        <Controller
                            name="technicians"
                            control={control}
                            render={(field) => (
                                <Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Technicians"
                                    onChange={(e) => {
                                        field.onChange(e);
                                    }}
                                >
                                    {technicianList.length === 0 && (<MenuItem disabled>Select Property First</MenuItem>)}
                                    {technicianList?.map(item => {
                                        return (<MenuItem key={item?.id} value={item?.id}>{item?.name}</MenuItem>)
                                    })}
                                </Select>
                            )}
                        />
                    </FormControl>
                    {errors.technicians && (<p className={`${styles.ErrorM}`}>{errors.technicians.message}</p>)}
                </div>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Frequency</InputLabel>
                        <Controller
                            name="days"
                            control={control}
                            render={(field) => (
                                <Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Frequency"
                                    multiple
                                    onChange={(e) => {
                                        field.onChange(e);

                                        if (e.target.value?.indexOf('All') > -1) {
                                            if (selectDays.length === daysList.length) {
                                                setValue('days', []);
                                                setSelectDays([]);
                                            } else {
                                                setValue('days', daysList);
                                                setSelectDays(daysList);
                                            }
                                        } else {
                                            setSelectDays(e.target.value);
                                        }
                                    }}
                                    input={<OutlinedInput label="Frequency" />}
                                    renderValue={(selected) => {
                                        return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                            {daysList?.map(item => {
                                                return (selected?.indexOf(item) > -1) ? (<Chip key={item} label={item} />) : null;
                                            })}
                                        </Box>
                                    }}
                                    MenuProps={MenuProps}
                                >
                                    <MenuItem value="All">
                                        <Checkbox
                                            checked={daysList.length > 0 && selectDays.length === daysList.length}
                                            indeterminate={selectDays.length > 0 && selectDays.length < daysList.length}
                                        />
                                        <ListItemText primary="Everyday" />
                                    </MenuItem>
                                    {daysList?.map(item => {
                                        return (<MenuItem key={item} value={item}>
                                            <Checkbox checked={selectDays.indexOf(item) > -1} />
                                            <ListItemText primary={item} />
                                        </MenuItem>)
                                    })}
                                </Select>
                            )}
                        />
                    </FormControl>
                    {errors.days && (<p className={`${styles.ErrorM}`}>{errors.days.message}</p>)}
                </div>
            </div>
            <div className={`${styles.ChecklistArea}`}>
                <p className={`${styles.TaskListTitle}`}>Tasks</p>
                {taskList?.length > 0 && <div className={`${styles.TasksNameListRow}`}>
                    {taskList?.map((item, index) =>
                        <TaskListCard item={item} index={index} index2={index} setTaskList={setTaskList.bind(this)} editTaskOpen={activeTaskId === index} setActiveTaskId={setActiveTaskId.bind(this)} />
                    )}

                </div>}
                {addTaskOpen && <div className={`${styles.HalfSecFull} ${styles.DeleteBU} FormGroup`}>
                    <TextField id="outlined-basic" label="Add a Task" variant="outlined" onChange={(e) => { setTaskError(false); setTaskVal(e?.target?.value); }} />
                    {taskError && <p className={`${styles.ErrorM}`}>This field is required</p>}
                </div>}
                {addTaskOpen && <div className={`${styles.ChecklistButtonAction}`}>
                    <Button className={`${styles.AddChecklistBU}`} onClick={(e) => addTask()}>Add</Button>
                    <Button className={`${styles.CancelChecklistBU}`} onClick={(e) => setAddTaskOpen(false)}>Cancel</Button>
                </div>}
                {!addTaskOpen && <button className={`${styles.AddTaskListBU}`} onClick={(e) => { setAddTaskOpen(true); setTaskError(false); setTaskVal(''); }}><Plus /> Add an Task</button>}
            </div>            
            <div className={`${styles.ButtonAction}`}>
                <Button onClick={(e) => setAddTaskModalOpen(false)} className="CancelPopupBU">Cancel</Button>
                <Button className="SubmitPopupBU" type="submit">Add</Button>
            </div>
        </div>
    </form>)
}

export default AddTaskForm;